<template>
  <div>
    <div class="current">
      <div v-for="item in tableData.data" :key="item.id" class="itembox">
        <div class="current-top">
          <div class="time">{{ timeFun(item.every_date) }}</div>
          <Button
            type="primary"
            html-type="submit"
            v-if="
              (item.status == 3 && !item.exam_info) ||
                (item.exam_info && item.exam_info.status < 3)
            "
            @click="
              $router.push(
                '/dayPractice/exam2?examination_id=' +
                  item.id +
                  '&name=' +
                  item.name
              )
            "
            >开始练习</Button
          >
        </div>
        <div class="current-con">
          <div class="leftbox">
            <div class="name">{{ item.name }}</div>
            <div>
              得分:{{ item.exam_info ? item.exam_info.total_score : 0 }}
            </div>
          </div>
          <div class="rightbox">
            <img
              v-if="item.exam_info && item.exam_info.status == 3"
              :src="kaoshijieshu"
              alt="练习结束"
            />
            <img v-if="item.status > 3" :src="kaoshijieshu" alt="练习结束" />
          </div>
        </div>
      </div>
    </div>

    <Page
      style="text-align: right;margin-bottom:10px"
      :total="tableData.total"
      :page-size="tableData.per_page"
      :current="tableData.current_page"
      show-total
      @on-change="getData"
    />
  </div>
</template>
<script>
import indexPage from "../../mixins/indexPage";
export default {
  data() {
    return {
      searchData: {
        type: 4,
        days: new Date().Format("yyyy-MM-dd")
      },
      newdate: new Date().Format("yyyy-MM-dd"),

      total_count: 0,
      left_count: 0,
      kaoshizhong: require("@/assets/images/examing.png"),
      kaoshijieshu: require("@/assets/images/examend.png"),
      kaoshiweikaishi: require("@/assets/images/examnotstart.png"),
      tableColumns: [
        { title: "ID", key: "id", align: "center", width: 80 },
        { title: "面授课程", key: "name", align: "center", minWidth: 120 },
        {
          title: "任教老师",
          key: "teacher_name",
          align: "center",
          minWidth: 120
        },
        {
          title: "上课时间",
          key: "learningTime",
          align: "center",
          minWidth: 120
        },
        {
          title: "原价",
          key: "original_price",
          align: "center",
          minWidth: 120
        },
        { title: "售价", key: "current_price", align: "center", minWidth: 120 },
        {
          title: "报名人数上限",
          key: "apply_num_limit",
          align: "center",
          minWidth: 120
        },
        // { title: "已报名人数", key: "period", align: "center"},
        { title: "操作", slot: "action", minWidth: 60, align: "center" }
      ],
      indexUrl: "/app/examination/index",
      userinfo: {} //当前登录用户信息
    };
  },
  mixins: [indexPage],
  props: {
    reSearch: {
      type: Object,
      default: () => ({
        name: "",
        type: 4
      })
    }
  },
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.searchData.days = this.newdate;
    this.getData(1);
  },
  methods: {
    search() {
      this.searchData.name = this.reSearch.name;
      this.getData(1);
    },
    timeFun(time) {
      if (time) {
        return time.split(" ")[0];
      }
      return "";
    }
  }
};
</script>
<style scoped lang="less">
.current {
  width: 100%;
  padding: 0 10px;
  margin-bottom: 15px;
  background: #fff;
  .itembox {
    width: 100%;
    border: 1px solid #eee;
    border-top: 5px solid #2d8cf0;
    border-radius: 8px;
    color: #222;
    margin-bottom: 15px;
    .current-top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      border-bottom: 1px solid #eee;
      .time {
        font-size: 18px;
        font-weight: 600;
      }
    }
    .current-con {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 20px;
      .leftbox {
        flex: 1;
        .name {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 3px;
        }
        > div {
          width: 100%;
          font-size: 15px;
        }
      }
      .rightbox {
        text-align: center;
        padding: 5px;
        img {
          width: 80px;
          height: 65px;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
